import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LuxonFormatPipe } from '../../pipes/luxon-format.pipe';
import { ToLuxonPipe } from '../../pipes/to-luxon.pipe';
import { LuxonTimezonePipe } from '../../pipes/luxon-timezone.pipe';
import { LuxonOffsetNameShortPipe } from '../../pipes/luxon-offset-name-short.pipe';
import { DateType } from '../../interfaces/common.interface';
import { luxonDateFormat, luxonTimeFormat } from '../../constants';

@Component({
  selector: 'twc-date-string',
  imports: [
    LuxonFormatPipe,
    ToLuxonPipe,
    LuxonTimezonePipe,
    LuxonOffsetNameShortPipe,
  ],
  templateUrl: './date-string.component.html',
  styleUrls: ['./date-string.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateStringComponent {
  @Input({ required: true }) date: string;
  @Input() fontClass = 'twc-typography-body-1';
  @Input() colorClass = 'twc-color-primary-typeface';
  @Input() showDate = true;
  @Input() showTime = true;
  @Input() showTimeZone = true;
  @Input() dateType = DateType.SQL;
  @Input() dateFormat = luxonDateFormat;
  @Input() timeFormat = luxonTimeFormat;

  @Input() inputTimeZone = 'UTC';
  @Input() targetTimezoneOne = 'local';
}
